import React, { Component } from 'react';
import { Button } from './ui/button';
import { AlertTriangle, RefreshCw, Home } from 'lucide-react';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, error: null, errorInfo: null };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
        // Log error to console for debugging
        console.error('ErrorBoundary caught an error:', error, errorInfo);
    }

    handleReload = () => {
        window.location.reload();
    };

    handleGoHome = () => {
        window.location.href = '/';
    };

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100 p-4">
                    <div className="max-w-md w-full bg-white rounded-2xl shadow-xl border border-slate-200 p-8 text-center">
                        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                            <AlertTriangle className="h-8 w-8 text-red-500" />
                        </div>

                        <h1 className="text-2xl font-bold text-slate-900 mb-2">
                            حدث خطأ غير متوقع
                        </h1>
                        <p className="text-slate-600 mb-6">
                            نعتذر عن هذا الخطأ. يرجى المحاولة مرة أخرى أو العودة للصفحة الرئيسية.
                        </p>

                        <div className="flex gap-3 justify-center">
                            <Button
                                onClick={this.handleReload}
                                className="bg-primary hover:bg-primary/90 rounded-full"
                            >
                                <RefreshCw className="h-4 w-4 mr-2" />
                                إعادة تحميل
                            </Button>
                            <Button
                                onClick={this.handleGoHome}
                                variant="outline"
                                className="rounded-full"
                            >
                                <Home className="h-4 w-4 mr-2" />
                                الرئيسية
                            </Button>
                        </div>

                        {process.env.NODE_ENV === 'development' && this.state.error && (
                            <div className="mt-6 p-4 bg-red-50 rounded-lg text-left text-xs overflow-auto max-h-40">
                                <p className="font-semibold text-red-700 mb-2">Error Details (Dev Only):</p>
                                <pre className="text-red-600 whitespace-pre-wrap">
                                    {this.state.error.toString()}
                                </pre>
                                {this.state.errorInfo && (
                                    <pre className="text-red-500 mt-2 whitespace-pre-wrap">
                                        {this.state.errorInfo.componentStack}
                                    </pre>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
